
import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../common/Layout'
import { dispatchMmvData, dispatchResetApiRequestQQ } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from 'react-select'
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper';
import { FaCheck, FaPlus } from 'react-icons/fa';
import _ from 'lodash';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import { isTomorrow } from 'date-fns';

const AddMmv = () => {
    const dispatch = useDispatch()
    const mmvData = useSelector(state => state?.root?.mmvData)
    const userDetails = useSelector(state => state?.root?.userDetails)
    const apiUrl = {
        IF: 'https://api.insurefast.in/api/v1/',
        // IF: 'https://test.insurefast.in/api/v1/',
        EC: 'https://api.expertcover.in/api/v3/',
        // EC: 'https://uatapi.expertcover.in/api/v3/',
    }

    const [vehicleType, setVehicleType] = useState('')
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const [makeData, setMakeData] = useState([])

    const [modelData, setModelData] = useState([])
    const [varientData, setVarientData] = useState([])


    const [makeId, setMakeId] = useState('')
    const [modelId, setModelId] = useState('')
    const [insurerData, setInsurerData] = useState([])


    const [selectedMake, setSelectedMake] = useState(null)
    const [selectedModal, setSelectedModal] = useState(null)
    const [selectedVarient, setSelectedVarient] = useState(null)
    const [insurerVarintCodeObj, setInsurerVarintCodeObj] = useState({});

    const [addMake, setAddMake] = useState()
    const [addModel, setAddModel] = useState()
    const [addVariant, setAddVariant] = useState()

    const [addFuel, setAddFuel] = useState("")
    const [addCC, setAddCC] = useState("")
    const [addGVW, setAddGVW] = useState("")
    const [addSeats, setAddSeats] = useState("")
    const [addCapacity, setAddCapacity] = useState("")
    const [addWheels, setAddWheels] = useState("")
    const [subClass, setSubClass] = useState('')
    const [addNewMmv, setAddnewMmv] = useState(false)
    const [bodyType, setBodyType] = useState(false)
    const [bodyTypeList, setBodyTypeList] = useState([]);
    const [bodyModal, setBodyModal] = useState(false)

    const [selectedBodyType, setSelectedBodyType] = useState("");

    const [variant, setVarient] = useState()
    const [idData, setIdData] = useState()

    const handleSelectProduct = val => {
        setLoading(true);

        // Add query parameters correctly, removing any extra commas
        let data = new URLSearchParams({
            isMmvPanel: true,
            vehicleType: vehicleType, // Ensure this is passed without any extra commas or spaces
        }).toString();

        GetDataWithToken(`/insurers/getAllInsurer?${data}`).then(res => {
            setLoading(false);
            if (res?.success) {
                setInsurerData(res?.data);
            } else {
                console.log('Insurer Data', res?.status);
            }
        });
    }

    const getBodyTypeByVehicleType = async (vehicleType) => {
        try {
            const response = await PostDataWithToken(
                "/mmv/getBodyTypeByVehicleType",
                {
                    vehicleType,
                    page: 1,
                    limit: 10,
                },
            );

            if (response?.data) {
                setBodyTypeList(response.data);
            } else {
                setBodyTypeList([]);
            }
        } catch (error) {
            console.error("Body Type API Error:", error);
            setBodyTypeList([]);
        }
    };

    const handleSelectVehicleType = val => {
        setSelectedVarient(null)
        setSelectedMake(null)
        setSelectedModal(null)
        setAddMake('')
        dispatchMmvData('makeId', '')
        dispatchMmvData('modelId', '')
        dispatchMmvData('variant', '')
        dispatchMmvData('make', '')
        dispatchMmvData('model', '')
        dispatchMmvData('varientId', '')
        setSelectedMake("")
        setSelectedModal("")
        setSelectedVarient("")
        setAddFuel("")
        setAddCC('')
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")

        const vehicleTypeClean = val?.trim();  // This ensures no trailing commas or spaces
        setVehicleType(vehicleTypeClean);
        dispatchMmvData('vehicleType', vehicleTypeClean);

        if (userDetails?.productOwner === 'EC') {
            dispatchMmvData('apiUrl', apiUrl?.EC);
        } else if (userDetails?.productOwner === 'IF') {
            dispatchMmvData('apiUrl', apiUrl?.IF);
        }
        getBodyTypeByVehicleType(vehicleTypeClean);
    };


    useEffect(() => {
        if (mmvData?.vehicleType) {
            handleSelectProduct(mmvData?.apiUrl);
            getMakeData()
        }
    }, [vehicleType, mmvData?.vehicleType]);

    const getMakeData = val => {
        setLoading(true)
        let makeObj = {
            vehicleType: mmvData?.vehicleType || val?.vehicleType
        }
        PostDataWithToken('/mmv/getAllMakeData', makeObj).then(
            res => {
                let data = res?.data
                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.make,
                        value: item?.makeId
                    })
                    i++
                }
                setMakeData(arr)
                setLoading(false)
            }
        )
    }

    // Get Modal Data
    const getModelData = val => {
        setModelData([])
        setVarientData([])

        dispatchMmvData('makeId', val)
        setLoading(true)
        let makeObj = {
            vehicleType: mmvData?.vehicleType,
            makeId: val
        }
        PostDataWithToken('/mmv/getAllModelData', makeObj).then(
            res => {
                let data = res?.data
                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.model,
                        value: item?.modelId
                    })
                    i++
                }
                setModelData(arr)
                setLoading(false)
            }
        )
    }
    //Get Variant Data
    const getVariantData = val => {
        setLoading(true)
        dispatchMmvData('modelId', val)
        let makeObj = {
            vehicleType: mmvData?.vehicleType,
            makeId: makeId ? makeId : mmvData?.makeId,
            modelId: val
        }
        PostDataWithToken('/mmv/getAllVariantData', makeObj).then(
            res => {
                let data = res?.data
                setVarient(data)


                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.variant,
                        value: item?.variantId
                    })
                    i++
                }
                setVarientData(arr)
                setLoading(false)
            }
        )
    }

    const handleSelectMake = (val, selectedOption) => {
        setSelectedVarient(null)
        setSelectedModal(null)
        const id = makeData.find(item => item.value === val)
        dispatchMmvData("make", id?.label)
        setMakeId(val)
        setIdData('')
        setAddFuel("")
        setAddCC('')
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")

        setSelectedMake(selectedOption)
        dispatchMmvData('makeId', val)

    }

    const handleSelectModel = (val, selectedOption) => {
        const id = modelData.find(item => item.value === val)
        dispatchMmvData("model", id?.label)
        setModelId(val)
        setIdData('')
        setSelectedVarient(null)
        setSelectedModal(selectedOption)
        dispatchMmvData('modelId', val)
    }
    const handleSelectVarient = (val, selectedOption) => {

        const id = variant.find(item => item.variantId === val)
        dispatchMmvData("variant", id?.variant)
        setIdData(id)

        setIdData(id)
        setSelectedVarient(selectedOption)
        dispatchMmvData('varientId', val)
    }

    const [makeModal, setMakeModal] = useState(false)
    const [modelModal, setModelModal] = useState(false)
    const [varientModal, setVarientModal] = useState(false)
    const [partnerMmvData, setPartnerMmvData] = useState([])
    const [variantIdInput, setVariantIdInput] = useState('')

    const [showSidebar, setShowSidebar] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const [editData, setEditData] = useState(null);

    const [editMake, setEditMake] = useState(null);
    const [editModel, setEditModel] = useState(null);
    const [editVariant, setEditVariant] = useState(null);
    const [sync, setSync] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

   const handlePageClick = (selectedItem) => {
    const page = selectedItem.selected + 1;
    setCurrentPage(page);
    getPartnerMMV({ page, limit: itemsPerPage, vehicleType: activeTab });
};


    const closeModal = () => {
        setMakeModal(false)
    }
    const closeModelModal = () => {
        setModelModal(false)
    }
    const closeVarientModal = () => {
        setVarientModal(false)
    }
    useEffect(() => {
        if (idData) {
            setAddSeats(idData.seats);
            setAddFuel(idData.fuelType);
            setAddCC(idData.cc);
            setAddCapacity(idData.carringCapacity);
            setAddGVW(idData.gvw);
            setAddWheels(idData.noOfWheels);
        }

    }, [idData]);


    const handleChangeMake = useCallback(
        _.debounce((value) => {
            console.log("make", value);
        }, 500),
        []
    );

    const handleAddMake = (e) => {
        dispatchMmvData('makeId', '')
        dispatchMmvData('modelId', '')
        dispatchMmvData('varientId', '')
        setSelectedMake("")
        setSelectedModal("")
        setSelectedVarient("")
        setAddFuel("")
        setAddCC('')
        setSubClass("")
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")
        setAddModel("")
        setAddVariant('');
        setAddMake(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddModel = (e) => {
        setAddModel(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddVarient = (e) => {
        setAddVariant(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddFuel = (e) => {
        dispatchMmvData('varientId', '')
        setAddFuel(e);
    };
    const handleAddCC = (e) => {
        dispatchMmvData('varientId', '')
        setAddCC(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddGVW = (e) => {
        dispatchMmvData('varientId', '')
        setAddGVW(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddCapacity = (e) => {
        dispatchMmvData('varientId', '')
        setAddCapacity(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddSeats = (e) => {
        dispatchMmvData('varientId', '')
        setAddSeats(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddWheels = (e) => {
        dispatchMmvData('varientId', '')
        setAddWheels(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddSubClass = (e) => {
        dispatchMmvData('varientId', '')
        setSubClass(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddBodyTppe = (e) => {
        setBodyType(e.target.value);
        handleChangeMake(e.target.value);
    };

    const validateAddMmv = () => {
        const validationErrors = {};

        if (!vehicleType) validationErrors.vehicleType = "Vehicle Type is required";
        if (!selectedBodyType && !bodyType) validationErrors.bodyType = "Body Type is required";
        if (!selectedMake && !addMake) validationErrors.make = "Make is required";
        if (!selectedModal && !addModel) validationErrors.model = "Model is required";
        if (!selectedVarient && !addVariant) validationErrors.variant = "Variant is required";
        if (!addFuel) validationErrors.fuel = "Fuel is required";
        if (!addCC) validationErrors.cc = "CC is required";
        if (!addSeats) validationErrors.seats = "Seats is required";
        if (!addGVW) validationErrors.gvw = "GVW is required";
        if (!addCapacity) validationErrors.capacity = "Carrying Capacity is required";
        if (!addWheels) validationErrors.wheels = "No. of Wheels is required";
        if (!subClass) validationErrors.subClass = "Sub Class is required";

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    useEffect(() => {
        const fieldValues = {
            vehicleType,
            bodyType: selectedBodyType || bodyType,
            make: selectedMake || addMake,
            model: selectedModal || addModel,
            variant: selectedVarient || addVariant,
            fuel: addFuel,
            cc: addCC,
            seats: addSeats,
            gvw: addGVW,
            capacity: addCapacity,
            wheels: addWheels,
            subClass,
        };

        setErrors((previousErrors) => {
            const nextErrors = { ...previousErrors };
            let hasChanges = false;

            Object.entries(fieldValues).forEach(([field, value]) => {
                if (value && nextErrors[field]) {
                    delete nextErrors[field];
                    hasChanges = true;
                }
            });

            return hasChanges ? nextErrors : previousErrors;
        });
    }, [
        vehicleType,
        selectedBodyType,
        bodyType,
        selectedMake,
        addMake,
        selectedModal,
        addModel,
        selectedVarient,
        addVariant,
        addFuel,
        addCC,
        addSeats,
        addGVW,
        addCapacity,
        addWheels,
        subClass,
    ]);

    const handleAddMmv = () => {
        if (!validateAddMmv()) {
            toast.error("Please fill all required fields");
            return;
        }

        let addMmvObj = {
            vehicleType: mmvData?.vehicleType,
            make: addMake || mmvData?.make,
            makeId: mmvData?.makeId || "",
            model: addModel || mmvData?.model,
            modelId: mmvData?.modelId || "",
            variant: addVariant || mmvData?.variant,
            variantId: mmvData?.varientId || "",
            fuelType: addFuel || idData?.fuelType,
            seats: idData?.seats || addSeats,
            cc: addCC || idData?.cc,
            carringCapacity: addCapacity || idData?.carringCapacity,
            subClass: subClass || idData?.subClass,
            gvw: addGVW || idData?.gvw,
            noOfWheels: addWheels || idData?.noOfWheels,
            bodyType: selectedBodyType || bodyType || idData?.bodyType,
            sync:sync,
            insurerVarintCodeObj: insurerVarintCodeObj,
        }



        PostDataWithToken("/mmv/getAddMmv", addMmvObj)
            .then(response => {
                toast.success(response?.message);
            }
            );
    }
    const handleInsChange = (e, key) => {
        const { value } = e.target;
        setInsurerVarintCodeObj((prev) => ({
            ...prev,
            [key]: value,
        }));
    };


const getPartnerMMV = ({
    makeId = "",
    modelId = "",
    variantId = "",
    action = "",
    search = variantIdInput,
    page = currentPage,
    limit = itemsPerPage,
    vehicleType = activeTab,
} = {}) => {
    setLoading(true);

    let partnerObj = {
        makeId: makeId === mmvData?.makeId ? mmvData?.makeId : makeId,
        mmvFullName: "",
        vehicleType: vehicleType,
        modelId: modelId === mmvData?.modelId ? mmvData?.modelId : modelId,
        variantId: variantId,
        search: variantIdInput,
        fuelType: "",
        insurerId: mmvData?.insurerId || "",
        action: action,
        limit: limit,
        page: page,
    };

    PostDataWithToken("/mmv/getMmvData", partnerObj)
        .then((res) => {
            setPartnerMmvData(res?.data || []);
            setPageCount(res?.totalPages || 0);
            setTotalRecords(res?.totalRecords);
            setLoading(false);
        })
        .catch(() => {
            setLoading(false);
        });
};
    const [itemOffset, setItemOffset] = useState(0);


    const endOffset = itemOffset + itemsPerPage;
    const currentItems =
        partnerMmvData && partnerMmvData.slice(itemOffset, endOffset);


    const handleStatusToggle = async (item) => {
        try {
            setLoading(true);

            const newStatus = !item.isActive;

            const response = await GetDataWithToken(
                `mmv/updateMmvStatus/${item.id}/status=${newStatus}`
            );

            toast.success(response.message);
            // Refresh Data
            getPartnerMMV();

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        getPartnerMMV()

    }, []);
const handleChangeItemPerPage = (value) => {
    const limit = Number(value);
    setItemsPerPage(limit);
    setCurrentPage(1);
    getPartnerMMV({ page: 1, limit, vehicleType: activeTab });
};
  const handleVariantIdChange = e => {
    setVariantIdInput(e.target.value)
  }
    const [searchType, setSearchType] = useState('search')
    const [isSearched, setIsSearched] = useState()
    const handleSearchToggle = () => {
        if (!isSearched) {
            // 👉 SEARCH MODE
            setItemOffset(0);
            getPartnerMMV('', '', '', '', variantIdInput)
            setIsSearched(true);
        } else {
            // 👉 RESET MODE
            setVariantIdInput("");
            setItemOffset(0);
            getPartnerMMV("", "", "", "", "");
            setIsSearched(false);
        }
    };

    const handleEditClick = async (item) => {
        dispatchMmvData('vehicleType', item?.vehicleType);
        dispatchMmvData('makeId', item?.makeId)
        dispatchMmvData('modelId', item?.modelId)
        dispatchMmvData('variantId', item?.variantId)
        setEditData(item);
        setShowSidebar(true);

        // Vehicle Type
        setVehicleType(item?.vehicleType || "");

        // Other Fields
        setAddFuel(item?.fuelType || "");
        setAddCC(item?.cc || "");
        setAddSeats(item?.seats || "");
        setAddGVW(item?.gvw || "");
        setAddCapacity(item?.carringCapacity || "");
        setAddWheels(item?.noOfWheels || "");
        setSubClass(item?.subClass || "");

        await getMakeData(item);
        // Selected Make
        const makeOption = {
            label: item?.make,
            value: item?.makeId,
        };

        // Selected Model
        const modelOption = {
            label: item?.model,
            value: item?.modelId,
        };

        // Selected Variant
        const variantOption = {
            label: item?.variant,
            value: item?.variantId,
        };

        // Set Make
        setEditMake(makeOption);

        // Load Models
        await getModelData(item.makeId);

        // Set Model
        setEditModel(modelOption);

        // Load Variants
        await getVariantData(item?.modelId);

        // Set Variant
        setEditVariant(variantOption);
    };
    const handleUpdateMmv = async () => {
        const payload = {
            id: editData?.id,

            vehicleType,

            makeId: editMake?.value,
            make: editMake?.label,

            modelId: editModel?.value,
            model: editModel?.label,

            variantId: editVariant?.value,
            variant: editVariant?.label,

            fuelType: addFuel,
            cc: addCC,
            seats: addSeats,
            gvw: addGVW,
            carringCapacity: addCapacity,
            noOfWheels: addWheels,
            subClass,
            sync: sync,
            insurerVarintCodeObj,
        };

        try {
            const res = await PostDataWithToken(
                `/mmv/updateMmv/${editData?.id}`,
                payload
            );

            if (res?.status) {
                toast.success(res.message);

                setShowSidebar(false);

                getPartnerMMV();
            } else {
                toast.error(res?.message || "Update Failed");
            }
        } catch (error) {
            toast.error("Update Failed");
        }
    };

    const [activeTab, setActiveTab] = useState("4W");
const handleVehicleTypeChange = (type) => {
    dispatchMmvData('makeId', '');
    dispatchMmvData('modelId', '');
    dispatchMmvData('vehicleType', type);
    setActiveTab(type);
    setCurrentPage(1);
    getPartnerMMV({ page: 1, limit: itemsPerPage, vehicleType: type });
};
    return (
        <div>
            <Layout>
                <div className='container-fluid py-4 dash_main'>
                    <div className="card">
                        <div className="card-body pt-0 pb-2 d-dlex align-itme-center d-flex justify-content-between">


                            <div className='col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gao-1'>
                                <div>
                                    <label>Search</label>
                                    <div className='mb-3'>
                                        <input
                                            type='search'
                                            placeholder='Search'
                                            className='form-control'
                                            value={variantIdInput}
                                            onChange={(e) => {
                                                setVariantIdInput(e.target.value);
                                                setIsSearched(false); // typing again makes it back to search mode
                                            }}
                                        />
                                    </div>
                                </div>
                                <div
                                    className='mt-3 secrch-btn'
                                >
                                    <button onClick={handleSearchToggle}>
                                        {isSearched ? "Reset" : "Search"}
                                    </button>
                                </div>
                            </div>


                            <div>
                                <button className="btn mt-2 btn-sec" onClick={() => setAddnewMmv(!addNewMmv)}>Add Mmv</button>
                            </div>

                        </div>

                    </div>
                    <div className="card mt-2">
                        <div className="card-body pt-0 pb-2">

                            <div className="d-flex justify-content-start gap-2 py-3">
                                <button
                                    type="button"
                                    className={`btn ${activeTab === "4W" ? "btn-sec" : "btn-outline-success"}`}
                                    onClick={() => handleVehicleTypeChange("4W")}
                                >
                                    4W
                                </button>

                                <button
                                    type="button"
                                    className={`btn ${activeTab === "2W" ? "btn-sec" : "btn-outline-success"}`}
                                    onClick={() => handleVehicleTypeChange("2W")}
                                >
                                    2W
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className='row mt-3'>
                        {addNewMmv &&
                            <div className='card mb-4'>
                                <div className='card-body pt-0 pb-2'>
                                    <div className='row mt-2'>
                                        <div className='col-xl-4 col-lg-3 col-md-6 col-12'>
                                            <label>Vehicle Type</label>
                                            <div className='mb-3'>
                                                <select
                                                    className='form-control'
                                                    onChange={e => handleSelectVehicleType(e.target.value)}
                                                    value={vehicleType}
                                                    name='vehicleType'
                                                    id='vehicleType'
                                                >
                                                    <option value=''>Select Vehicle</option>
                                                    <option value='2w'>Two Wheeler</option>
                                                    <option value='4w'>Private Car</option>
                                                    <option value='pcv'>Passenger Carrying Vehicle</option>
                                                    <option value='gcv'>Goods Carrying Vehicle</option>
                                                    <option value='misc'>Miscellaneous Vehicle</option>
                                                </select>
                                                {errors.vehicleType && (
                                                    <div className='text-danger'>{errors.vehicleType}</div>
                                                )}
                                            </div>
                                        </div>


                                        <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                            <div className='d-flex'>
                                                <div className='col-10'>
                                                    <label>Body Type</label>

                                                    <select
                                                        className="form-control"
                                                        value={selectedBodyType}
                                                        onChange={(e) => setSelectedBodyType(e.target.value)}
                                                    >
                                                        <option value="">Select Body Type</option>

                                                        {bodyTypeList?.map((item) => (
                                                            <option
                                                                key={item._id || item.id}
                                                                value={item.bodyType}
                                                            >
                                                                {item.bodyType}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.bodyType && <div className='text-danger'>{errors.bodyType}</div>}

                                                </div>

                                                <div>
                                                    <div
                                                        className='add-sec'
                                                        onClick={() => setBodyModal(!bodyType)}
                                                    >
                                                        <FaPlus />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='mt-2'>
                                                {bodyModal && (
                                                    <div className='d-flex align-center' style={{ width: "92%" }}>
                                                        <input
                                                            type='text'
                                                            placeholder='Enter Body Type'
                                                            className='form-control'
                                                            name='bodyType'
                                                            onChange={handleAddBodyTppe}
                                                        />
                                                    </div>

                                                )}
                                                <div>
                                                </div>
                                            </div>

                                        </div>


                                        <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                            <div className='d-flex'>
                                                <div className='col-10'>
                                                    <label>Make</label>
                                                    <ReactSelect
                                                        options={makeData}
                                                        name='Make'
                                                        placeholder='Select make'
                                                        value={selectedMake}
                                                        onChange={e => {
                                                            handleSelectMake(e?.value, e)
                                                            getModelData(e?.value)
                                                        }}
                                                    />
                                                    {errors.make && <div className='text-danger'>{errors.make}</div>}

                                                </div>

                                                <div>
                                                    <div
                                                        className='add-sec'
                                                        onClick={() => setMakeModal(!makeModal)}
                                                    >
                                                        <FaPlus />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='mt-2'>
                                                {makeModal && (
                                                    <div className='d-flex align-center' style={{ width: "92%" }}>
                                                        <input
                                                            type='text'
                                                            placeholder='Enter Make Name'
                                                            className='form-control'
                                                            name='Make'
                                                            onChange={handleAddMake}
                                                        />
                                                    </div>

                                                )}
                                                <div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                            <div className='d-flex'>
                                                <div className='col-10'>
                                                    <label>Model</label>
                                                    <ReactSelect
                                                        options={modelData}
                                                        name='Model'
                                                        placeholder='Select model'
                                                        value={selectedModal}
                                                        onChange={e => {
                                                            handleSelectModel(e?.value, e)
                                                            getVariantData(e?.value)
                                                        }}
                                                    />
                                                    {errors.model && <div className='text-danger'>{errors.model}</div>}

                                                </div>

                                                <div>
                                                    <div
                                                        className='add-sec '
                                                        onClick={() => setModelModal(!modelModal)}
                                                    >
                                                        <FaPlus />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='mt-2'>
                                                {modelModal && (
                                                    <div className='d-flex align-center' style={{ width: "92%" }}>
                                                        <input
                                                            type='text'
                                                            placeholder='Enter Model Name'
                                                            className='form-control'
                                                            name='Model'
                                                            value={addModel}
                                                            onChange={handleAddModel}
                                                        />

                                                    </div>

                                                )}
                                                <div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                            <div className='d-flex'>
                                                <div className='col-10'>
                                                    <label>Varient</label>
                                                    <ReactSelect
                                                        options={varientData}
                                                        name='Varient'
                                                        placeholder='Select Varient'
                                                        value={selectedVarient}
                                                        onChange={e => handleSelectVarient(e?.value, e)}
                                                    />
                                                    {errors.variant && <div className='text-danger'>{errors.variant}</div>}

                                                </div>

                                                <div>
                                                    <div
                                                        className='add-sec'
                                                        onClick={() => setVarientModal(!varientModal)}
                                                    >
                                                        <FaPlus />
                                                    </div>
                                                    {/* <div className='hide'>Add New</div> */}
                                                </div>

                                            </div>

                                            <div className='mt-2'>
                                                {varientModal && (
                                                    <div className='d-flex align-center' style={{ width: "92%" }}>
                                                        <input
                                                            type='text'
                                                            value={addVariant}
                                                            placeholder='Enter Varient Name'
                                                            className='form-control'
                                                            name='Varient'
                                                            onChange={handleAddVarient}
                                                        />

                                                    </div>

                                                )}
                                                <div>

                                                    {/* <div className='hide'>Add New</div> */}
                                                </div>
                                            </div>

                                        </div>
                                           <div className="col-md-4">
                                    <label>Sync</label>
                                    <select
                                        className="form-control mt-2"
                                        value={sync.toString()}
                                        onChange={(e) => setSync(e.target.value === "true")}
                                    >
                                        <option value="">Select Sync</option>
                                        <option value="false">False</option>
                                        <option value="true">True</option>
                                    </select>
                                </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>Fuel</label>
                                                {/* <input
                                                type='text'
                                                defaultValue={idData?.fuelType}
                                                value={idData?.fuelType || addFuel}
                                                placeholder='Enter Fuel Type'
                                                className='form-control'
                                                name='Fuel'
                                                onChange={handleAddFuel}

                                            /> */}
                                                <select class="form-control"
                                                    id="fuelSelect"
                                                    name="fuelSelect"
                                                    value={addFuel}
                                                    onChange={e => handleAddFuel(e.target.value)}
                                                >
                                                    <option value="">Select fuel</option>
                                                    <option value="Petrol">Petrol</option>
                                                    <option value="Diesel">Diesel</option>
                                                    <option value="LPG">LPG</option>
                                                    <option value="CNG">CNG</option>
                                                    <option value="Electric">Electric</option>
                                                </select>
                                                {errors.fuel && <div className='text-danger'>{errors.fuel}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>CC</label>
                                                <input
                                                    type='text'
                                                    value={addCC}
                                                    placeholder='Enter CC'
                                                    className='form-control'
                                                    name='CC'
                                                    onChange={handleAddCC}
                                                />
                                                {errors.cc && <div className='text-danger'>{errors.cc}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>Seats</label>
                                                <input
                                                    value={addSeats}
                                                    type='text'
                                                    placeholder='Enter Seats'
                                                    className='form-control'
                                                    name='Seats'
                                                    onChange={handleAddSeats}
                                                />
                                                {errors.seats && <div className='text-danger'>{errors.seats}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>GVW</label>
                                                <input
                                                    type='text'
                                                    value={addGVW}
                                                    placeholder='Enter GVW'
                                                    className='form-control'
                                                    name='GVW'
                                                    onChange={handleAddGVW}
                                                />
                                                {errors.gvw && <div className='text-danger'>{errors.gvw}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>Carring Capacity</label>
                                                <input
                                                    type='text'
                                                    value={addCapacity}
                                                    placeholder='Enter Carring Capacity'
                                                    className='form-control'
                                                    name='Carring Capacity'
                                                    onChange={handleAddCapacity}
                                                />
                                                {errors.capacity && <div className='text-danger'>{errors.capacity}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>No Of Wheels</label>
                                                <input
                                                    type='text'
                                                    placeholder='Enter no Of wheels'
                                                    value={addWheels}
                                                    className='form-control'
                                                    name='No Of Wheels'
                                                    onChange={handleAddWheels}
                                                />
                                                {errors.wheels && <div className='text-danger'>{errors.wheels}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xl-2'>
                                            <div className='mb-3'>
                                                <label>Sub Class</label>
                                                <input
                                                    type='text'
                                                    placeholder='Enter no Of wheels'
                                                    value={subClass}
                                                    className='form-control'
                                                    name='sub class'
                                                    onChange={handleAddSubClass}
                                                />
                                                {errors.subClass && <div className='text-danger'>{errors.subClass}</div>}
                                            </div>
                                        </div>
                                    </div>
                                   
                                    <div className='row'>
                                        {insurerData?.map((item) => (
                                            <div key={item.id} className="mb-4 col-4">
                                                <div className="d-flex flex-column">
                                                    <label className="text-sm text-capitalize font-medium text-gray-700 mb-1">
                                                        {item?.mappingName}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={`Enter ${item?.mappingName} Code`}
                                                        value={insurerVarintCodeObj[item?.mappingName] || ''}
                                                        onChange={(e) => handleInsChange(e, item?.mappingName)}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='col-xl-12 col-lg-3 col-md-6 col-12'>
                                        <label></label>
                                        <div className='mb-3 d-flex justify-content-end gap-3'>
                                            <button
                                                type='button'
                                                className='btn btn-sec'
                                                onClick={handleAddMmv}

                                            >
                                                {loading ? 'Loading...' : 'Submit'}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }


                        <div className='card-body pt-0 pb-2'>
                            <div className='table-responsive p-0'>
                                <table className="table align-items-center mb-0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Make</th>
                                            <th>Model</th>
                                            <th>Variant</th>
                                            <th>Body Type</th>
                                            <th>Mmv Full Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {partnerMmvData?.length > 0 ? (
                                            partnerMmvData.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item?.variantId}</td>
                                                    <td>{item?.make}</td>
                                                    <td>{item?.model}</td>
                                                    <td>{item?.variant}</td>
                                                    <td>{item?.bodyType}</td>

                                                    <td>{item?.mmvFullName}</td>
                                                    <td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <div
                                                                    className={`custom-switch ${item?.isActive ? "active" : ""}`}
                                                                    onClick={() => handleStatusToggle(item)}
                                                                >
                                                                    <div className="switch-circle"></div>
                                                                </div>

                                                                <span
                                                                    className={`fw-semibold ${item?.status ? "text-success" : "text-danger"
                                                                        }`}
                                                                >

                                                                </span>
                                                            </div>
                                                        </td>
                                                    </td>

                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sec"
                                                            onClick={() => handleEditClick(item)}
                                                        >
                                                            Update
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='card mb-4 p-3'>
                            <div className='d-flex align-items-center justify-content-between flex-wrap'>
                                <div>
                                    <p>
                                        Showing {(currentPage - 1) * itemsPerPage + 1} -
                                        {Math.min(currentPage * itemsPerPage, totalRecords)}
                                        {" "}of {totalRecords}
                                    </p>
                                </div>
                                <div className='main-page-item'>
                                    <div className='show-page'>
                                        <select
                                            className="form-control"
                                            value={itemsPerPage}
                                            onChange={(e) =>
                                                handleChangeItemPerPage(e.target.value)
                                            }
                                        >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={30}>30</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                    </div>
                                    <div>
                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel=">"
                                            previousLabel="<"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            forcePage={currentPage - 1}
                                            renderOnZeroPageCount={null}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

                {showSidebar && (
                    <>
                        <div
                            className="sidebar-overlay"
                            onClick={() => setShowSidebar(false)}
                        />

                        <div className="right-sidebar open">
                            <div className="sidebar-header">
                                <h4>Update MMV</h4>

                                <button
                                    className="close-btn"
                                    onClick={() => setShowSidebar(false)}
                                >
                                    ×
                                </button>
                            </div>

                            <div className="sidebar-body">

                                <div className="mb-3">
                                    <label>Make</label>

                                    <ReactSelect
                                        options={makeData}
                                        value={editMake}
                                        placeholder="Select Make"
                                        onChange={(e) => {
                                            setEditMake(e);
                                            setEditModel(null);
                                            setEditVariant(null);

                                            getModelData(e.value);
                                        }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Model</label>

                                    <ReactSelect
                                        options={modelData}
                                        value={editModel}
                                        placeholder="Select Model"
                                        onChange={(e) => {
                                            setEditModel(e);
                                            setEditVariant(null);

                                            getVariantData(e.value);
                                        }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Variant</label>

                                    <ReactSelect
                                        options={varientData}
                                        value={editVariant}
                                        placeholder="Select Variant"
                                        onChange={(e) => {
                                            setEditVariant(e);
                                        }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Fuel Type</label>

                                    <select
                                        className="form-control"
                                        value={addFuel}
                                        onChange={(e) =>
                                            setAddFuel(e.target.value)
                                        }
                                    >
                                        <option value="">Select Fuel</option>
                                        <option value="Petrol">Petrol</option>
                                        <option value="Diesel">Diesel</option>
                                        <option value="CNG">CNG</option>
                                        <option value="LPG">LPG</option>
                                        <option value="Electric">Electric</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label>CC</label>
                                    <input
                                        className="form-control"
                                        value={addCC}
                                        onChange={(e) =>
                                            setAddCC(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Seats</label>
                                    <input
                                        className="form-control"
                                        value={addSeats}
                                        onChange={(e) =>
                                            setAddSeats(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>GVW</label>
                                    <input
                                        className="form-control"
                                        value={addGVW}
                                        onChange={(e) =>
                                            setAddGVW(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Carrying Capacity</label>
                                    <input
                                        className="form-control"
                                        value={addCapacity}
                                        onChange={(e) =>
                                            setAddCapacity(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>No Of Wheels</label>
                                    <input
                                        className="form-control"
                                        value={addWheels}
                                        onChange={(e) =>
                                            setAddWheels(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Sub Class</label>
                                    <input
                                        className="form-control"
                                        value={subClass}
                                        onChange={(e) =>
                                            setSubClass(e.target.value)
                                        }
                                    />
                                </div>
                                  <div className="mb-3">
                                    <label>Sync</label>
                                    <select
                                        className="form-control mt-2"
                                        value={sync.toString()}
                                        onChange={(e) => setSync(e.target.value === "true")}
                                    >
                                        <option value="">Select Sync</option>
                                        <option value="false">False</option>
                                        <option value="true">True</option>
                                    </select>
                                </div>
                                

                                <button
                                    className="btn btn-sec w-100"
                                    onClick={handleUpdateMmv}
                                >
                                    Update MMV
                                </button>

                            </div>
                        </div>
                    </>
                )}

            </Layout>
        </div>
    )
}

export default AddMmv
